import { FC, useState } from "react"
import { Select } from "antd"
import { getAccounts } from "domains/accounts/api/accounts.call"
import { AccountOption } from "../store/types"
import { useDebouncedCallback } from "use-debounce"

interface Props {
  value?: AccountOption[];
  onChange?: (value: AccountOption[]) => void;
  placeholder?: string;
}

export const AccountSelect: FC<Props> = ({ value, onChange, placeholder }) => {
  const [options, setOptions] = useState<AccountOption[]>([])
  const [fetching, setFetching] = useState(false)

  const handleSearch = useDebouncedCallback(async(search: string) => {
    setFetching(true)
    try {
      const res = await getAccounts(search, 1, 10)
      setOptions(
        (res.data || []).map((a: any) => ({
          value: a.id,
          label: `${a.nickname || a.email || a.id} (${a.email || a.id})`,
        })),
      )
    } catch {
      setOptions([])
    } finally {
      setFetching(false)
    }
  }, 400)

  // Merge fetched options with currently selected so labels are preserved
  const mergedOptions = [
    ...(value || []).filter(v => !options.some(o => o.value === v.value)),
    ...options,
  ]

  return (
    <Select
      mode="multiple"
      labelInValue
      filterOption={false}
      showSearch
      onSearch={handleSearch}
      notFoundContent={fetching ? "Loading..." : "No accounts found"}
      options={mergedOptions}
      value={value}
      onChange={onChange}
      placeholder={placeholder ?? "Search by name or email…"}
      style={{ width: "100%" }}
    />
  )
}
